// src/analytics/consent.js
const STORAGE_KEY = 'monite_consent';
const TTL_MONTHS = 13;

function ensureGtag() {
  if (typeof window === 'undefined') return null;
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
  }
  return window.gtag;
}

export function setConsentDefaultDenied() {
  const gtag = ensureGtag();
  if (!gtag) return;
  gtag('consent', 'default', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  });
}

export function setConsentGranted() {
  const gtag = ensureGtag();
  if (!gtag) return;
  gtag('consent', 'update', {
    analytics_storage: 'granted',
    ad_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted',
  });
  persistChoice('accepted');
}

export function setConsentRefused() {
  // gtag default reste 'denied' — on persist juste le choix utilisateur
  persistChoice('refused');
}

function persistChoice(choice) {
  try {
    const payload = { choice, date: new Date().toISOString() };
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (e) {}
}

export function getStoredConsent() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data.choice || !data.date) return null;
    const ageMs = Date.now() - new Date(data.date).getTime();
    const ttlMs = TTL_MONTHS * 30 * 24 * 60 * 60 * 1000;
    if (ageMs > ttlMs) {
      window.localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return data;
  } catch (e) {
    return null;
  }
}

export function clearStoredConsent() {
  try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) {}
}

export function hasGivenConsent() {
  const stored = getStoredConsent();
  return stored?.choice === 'accepted';
}
